module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/keys.js
 ** module id = 410
 ** module chunks = 0 11 12 14 15 16 19 20 34
 **/